module.exports = __webpack_public_path__ + "6f03774990ce50841bb1f0a1cafb0884.png";